import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class UsersApiClient {
  constructor(private commonService: CommonService) {}

  getUsers(payload: unknown): Observable<unknown> {
    return this.commonService.API_POST(EndPoints.GetUsers, payload, false);
  }

  getRoles(): Observable<unknown> {
    return this.commonService.API_GET(EndPoints.GetRoles, false);
  }

  getUserSites(): Observable<unknown> {
    return this.commonService.API_GET(EndPoints.UserSites, true);
  }
}
